import React from "react";
import { Menu, Dropdown, Button } from "antd";
import { BUTTON_CONSTANTS } from "./ManageSchedulers";
import SwitchIcon from "../../../assets/switch-icon-2.png";
import TransferOwnership from "../../../assets/transfer_ownership.svg"


const ActionButtonDropdown = (props) => {
  const { user_type, handleButtonClick } = props;

  const menu = (
    <Menu style={{ zIndex: 999, display: "flex", flexDirection: "column", alignItems: "center" }}
      className="manageScheduler-table-btn"
    >
      <Menu.Item>
        <Button
          // style={{width: '100%'}}
          className="manageScheduler-dropdown-table-btn borderRadius-28"
          type="default"
          onClick={() =>
            handleButtonClick(BUTTON_CONSTANTS.transfer_ownership.key)
          }
        >
          &nbsp;
          {BUTTON_CONSTANTS.transfer_ownership.label}
        </Button>
      </Menu.Item>
      <Menu.Item>
        <Button
          className="manageScheduler-dropdown-table-btn borderRadius-28"
          style={{ marginTop: "7px" }}
          type="default"
          onClick={(e) => {
            handleButtonClick(BUTTON_CONSTANTS.unlink_user.key);
          }}
        >
          &nbsp;
          {BUTTON_CONSTANTS.unlink_user.label}
        </Button>
      </Menu.Item>
    </Menu>
  );

  // Direct container reference to override App.js configuration
  const getCustomContainer = () => document.body;

  return (
    <div  >
      {" "}
      <Dropdown
        overlay={menu}
        placement="bottomCenter"
        style={{ display: "flex", marginTop: "-7px" }}
        className="manageScheduler-table-btn"
        getPopupContainer={getCustomContainer}
      >
        <Button className="borderRadius-28"
          disabled={false}
        >
          <img src={TransferOwnership} alt="Switch Icon" />
          &nbsp; Transfer Ownership
        </Button>
      </Dropdown>
    </div>
  );
};

export default ActionButtonDropdown;



// WEBPACK FOOTER //
// ./src/scenes/ManageUsers/ManageSchedulers/ActionButtonDropdown.js